import React from 'react';
import Forms from './components/Forms';
import Newsletters from './components/Newsletters';
import Studies from './components/Studies';
import FactSheets from './components/FactSheets';
import PressReleases from './components/PressReleases';
import Videos from './components/Videos';
import EducationMultimedia from './components/EducationMultimedia';
import News from './components/News';

const routes = [
  {
    path: '/Publications/Forms',
    renderer: (params = {}): JSX.Element => <Forms {...params} />,
  },
  {
    path: '/Publications/Newsletters',
    renderer: (params = {}): JSX.Element => <Newsletters {...params} />,
  },
  {
    path: '/Publications/Studies',
    renderer: (params = {}): JSX.Element => <Studies {...params} />,
  },
  {
    path: '/Publications/Factsheets',
    renderer: (params = {}): JSX.Element => <FactSheets {...params} />,
  },
  {
    path: '/Publications/Pressreleases',
    renderer: (params = {}): JSX.Element => <PressReleases {...params} />,
  },
  {
    path: '/Publications/Videos',
    renderer: (params = {}): JSX.Element => <Videos {...params} />,
  },
  {
    path: '/Home/EducationMultimedia',
    renderer: (params = {}): JSX.Element => <EducationMultimedia {...params} />,
  },
  {
    path: '/Publications/EducationMultimedia',
    renderer: (params = {}): JSX.Element => <EducationMultimedia {...params} />,
  },
  {
    path: '/Home/News',
    renderer: (params = {}): JSX.Element => <News {...params} />,
  },
  {
    path: '/Publications/News',
    renderer: (params = {}): JSX.Element => <News {...params} />,
  }
];



export default routes;
